const contact = () => {
  const buttons = document.querySelectorAll('.contact-btn');

  const setContact = (link, email) => {
    link.setAttribute('href', 'mailto:'.concat(atob(email)));
  };

  buttons.forEach((button) => {
    const email = button.dataset.contact;
    setContact(button, email);
  });
};

export default contact;
